import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mx-auto" }
const _hoisted_3 = { class: "flex gap-3 flex-row justify-between items-start" }
const _hoisted_4 = { class: "text-lg text-gray-900 font-semibold mb-0" }
const _hoisted_5 = { class: "mb-6 text-gray-600 font-medium text-sm" }
const _hoisted_6 = { class: "flex flex-row w-full justify-end" }
const _hoisted_7 = ["onClick", "disabled"]
const _hoisted_8 = { class: "flex justify-between items-center w-full" }
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = { class: "font-semibold mr-2" }
const _hoisted_11 = { class: "bg-blue-50 border border-blue-200 rounded-full py-1 px-2 w-[90px] text-center text-blue-600 text-xs font-medium mr-4" }
const _hoisted_12 = { class: "flex" }
const _hoisted_13 = { class: "inline-flex items-center cursor-pointer mr-4" }
const _hoisted_14 = ["checked", "disabled", "onChange"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "relative w-11 h-6 bg-gray-100 peer-focus:outline-none rounded-full peer dark:bg-gray-100 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600" }, null, -1)
const _hoisted_16 = { class: "text-gray-600 font-semibold text-sm" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex item-center justify-between mt-6" }
const _hoisted_20 = { class: "h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 me-0" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "p-4" }
const _hoisted_23 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_24 = { class: "mt-5 text-center" }
const _hoisted_25 = { class: "text-lg font-semibold mb-1" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "text-sm text-gray-600 mb-8" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_29 = { class: "mt-6 flex justify-around items-center flex-row" }
const _hoisted_30 = { class: "p-8 relative" }
const _hoisted_31 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_32 = { class: "mt-6 text-center" }
const _hoisted_33 = { class: "text-lg font-semibold leading-6 text-gray-900" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "text-sm text-gray-600 mb-4" }
const _hoisted_36 = { class: "text-sm text-gray-600" }
const _hoisted_37 = { class: "mt-6 flex justify-around items-center flex-col" }
const _hoisted_38 = {
  type: "button",
  class: "px-8 text-base mt-3 flex flex-row justify-evenly items-center flex-wrap w-full"
}
const _hoisted_39 = { class: "text-sm text-gray-600" }
const _hoisted_40 = { class: "text-sm text-blue-600 ms-1" }
const _hoisted_41 = { class: "p-8 relative" }
const _hoisted_42 = { class: "mx-auto flex items-center justify-center" }
const _hoisted_43 = { class: "text-purple-100" }
const _hoisted_44 = { class: "mt-6 text-center" }
const _hoisted_45 = { class: "text-lg font-semibold leading-6 text-gray-900" }
const _hoisted_46 = { class: "mt-4 text-center" }
const _hoisted_47 = { class: "text-sm text-gray-600 mb-4" }
const _hoisted_48 = { class: "text-gray-600" }
const _hoisted_49 = { class: "mt-6 flex justify-around items-center flex-col" }
const _hoisted_50 = {
  type: "button",
  class: "bg-blue-600 rounded-lg p-2.5 text-base shadow-lg text-white mx-2 flex flex-row justify-center items-center flex-wrap w-full"
}
const _hoisted_51 = { class: "text-sm text-gray-600" }
const _hoisted_52 = { class: "text-sm text-blue-600 ms-1" }

import { ref, onBeforeMount, computed } from "vue";
import { useSchoolStore } from "@/stores/schoolStore";
import { useUserStore } from "@/stores/userStore";
import ClassStructure from "@/modules/main/components/ClassStructureComponent.vue";
import { useRolloverStore } from "@/stores/rolloverStore";
import { Rollover } from "@/interfaces/rollover.interface";
import router from "@/router";
import InternalViewNav from '@/modules/main/components/InternalViewNav.vue';
import {
  VideoCameraIcon,
} from "@heroicons/vue/24/outline";
import TutorialModalComponent from "../components/TutorialModalComponent.vue";

// Data Stores

export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewClassStructureView',
  setup(__props) {

const schoolStore = useSchoolStore();
const rolloverStore = useRolloverStore();
const userStore = useUserStore();

// Local State
const goToAssignModal = ref(false);
const completeClassReviewModal = ref(false);
const currentOpenGrade = ref<number | undefined>(0);
const showModal = ref(false);
const grades = Array.from({ length: 12 }, (_, i) => i + 1); // Grades 1 to 12
const showAddGradeConfirm = ref(false);
const selectedGrade = ref<number | null>(null);

const isInternalAdmin = computed(() => userStore.isInternalAdmin);

onBeforeMount(async () => {
  currentOpenGrade.value = schoolStore.currentSchoolStructure?.gradeLevels[0];
  console.log("currentOpenGrade", currentOpenGrade.value);

  const currentRollOver = rolloverStore.rollover as Rollover;

  if (currentRollOver && currentRollOver.status.classReview === "to_do") {
    currentRollOver.status.classReview = "in_review";
    await rolloverStore.updateRolloverObject(currentRollOver);
  }
});

const confirmClassReview = async () => {
  const currentRollOver = rolloverStore.rollover as Rollover;

  if (currentRollOver) {
    currentRollOver.status.classReview = "pending_job_run";
    await rolloverStore.updateRolloverObject(currentRollOver);
  }

  completeClassReviewModal.value = false;
  router.push("/main/internal");
};

const learnersByGrade = ref<{ [key: number]: number }>({});

const updateLearnerCount = ({ gradeLevel, learnerCount }: { gradeLevel: number; learnerCount: number }) => {
  learnersByGrade.value[gradeLevel] = learnerCount;
};

// Grades Addition
const handleGradeCheckboxChange = (grade: number, event: Event) => {
  const target = event.target as HTMLInputElement;
  const currentlyIncluded = schoolStore.currentSchoolStructure?.gradeLevels.includes(grade);

  if (!currentlyIncluded && target.checked) {
    // User is trying to add a grade not included yet, show confirmation modal
    selectedGrade.value = grade;
    showAddGradeConfirm.value = true;
    // Temporarily revert the checkbox visually until user confirms
    target.checked = false;
  } else {
    // If it's already included and user tries to uncheck, either do nothing or revert the checkbox
    // For now, we revert to checked to prevent removal:
    if (currentlyIncluded && !target.checked) {
      target.checked = true;
    }
  }
};

const confirmSelection = async (grade: number | null) => {
  if (grade === null) return;

  // Retrieve the current school from the store
  const currentSchool = schoolStore.getCurrentSchool;

  if (!currentSchool) {
    console.error("No current school loaded");
    return;
  }

  // Take existing grade levels, add the new grade
  const updatedGradeLevels = currentSchool.gradeLevels
    ? [...currentSchool.gradeLevels, grade]
    : [grade];

  // Call the updateSchool method to persist this change
  const success = await schoolStore.updateSchool(currentSchool._id, {
    gradeLevels: updatedGradeLevels,
  });

  // Update The School Structure
  await schoolStore.fetchSchoolStructure(currentSchool._id);

  if (!success) {
    console.error("Failed to update the school with the new grade");
    // Optionally show an error message or revert the checkbox state
    return;
  }
  
  // // Add the selected grade to the school's gradeLevels array
  // const currentStructure = schoolStore.currentSchoolStructure;
  // if (currentStructure && !currentStructure.gradeLevels.includes(grade)) {
  //   currentStructure.gradeLevels.push(grade);
  //   await schoolStore.updateSchool(currentStructure); 
  //   // This should be a call to your store action or API to persist the change
  // }

  showAddGradeConfirm.value = false;
  selectedGrade.value = null;
};

const cancelSelection = () => {
  showAddGradeConfirm.value = false;
  selectedGrade.value = null;
};

return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      (isInternalAdmin.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(InternalViewNav)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.title")), 1),
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.sub_title")) + ". ", 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              type: "button",
              class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg flex flex-row items-center gap-1.5",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
            }, [
              _createVNode(_unref(VideoCameraIcon), {
                class: "-ml-0.5 h-5 w-5",
                "aria-hidden": "true"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("global.tutorial")), 1)
            ])
          ])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(grades), (grade) => {
          return (_openBlock(), _createElementBlock("div", { key: grade }, [
            _createElementVNode("button", {
              onClick: ($event: any) => (
            _unref(schoolStore).currentSchoolStructure?.gradeLevels.includes(grade) &&
            (currentOpenGrade.value == grade
              ? (currentOpenGrade.value = 0)
              : (currentOpenGrade.value = grade))
          ),
              disabled: !_unref(schoolStore).currentSchool?.gradeLevels.includes(grade),
              class: _normalizeClass([
            'accordion-title flex flex-col rounded-lg bg-white border border-gray-200 mb-4 w-full px-4 py-8',
            { 
              'cursor-not-allowed opacity-70': !_unref(schoolStore).currentSchoolStructure?.gradeLevels.includes(grade)
            }
          ])
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.grade")) + " " + _toDisplayString(grade), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", null, _toDisplayString(learnersByGrade.value[grade] || 0) + " " + _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.students")), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      value: "",
                      class: "sr-only peer",
                      checked: _unref(schoolStore).currentSchool?.gradeLevels.includes(grade),
                      disabled: _unref(schoolStore).currentSchool?.gradeLevels.includes(grade),
                      onChange: ($event: any) => (handleGradeCheckboxChange(grade, $event))
                    }, null, 40, _hoisted_14),
                    _hoisted_15
                  ]),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.view")), 1),
                  (currentOpenGrade.value == grade)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                        _createVNode(_component_rl_icon, {
                          icon: 'rl-dark-arrow-down',
                          title: 'rl dark arrow down',
                          "aria-hidden": "true"
                        })
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_18, [
                        _createVNode(_component_rl_icon, {
                          icon: 'rl-dark-arrow-up',
                          title: 'rl dark arrow up',
                          "aria-hidden": "true"
                        })
                      ]))
                ])
              ])
            ], 10, _hoisted_7),
            _withDirectives(_createElementVNode("div", null, [
              _createVNode(ClassStructure, {
                gradeLevel: grade,
                onUpdateLearnerCount: updateLearnerCount
              }, null, 8, ["gradeLevel"])
            ], 512), [
              [_vShow, currentOpenGrade.value == grade]
            ])
          ]))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(_component_router_link, {
          to: "/main/incomplete-rollover",
          class: "justify-center font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-4 font-medium flex items-center bg-transparent shadow-[0px_1px_2px_0px_rgba(16,24,40,0.05)] text-center bg-white"
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", _hoisted_20, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-small-back-arrow',
                title: 'rl small back arrow',
                "aria-hidden": "true"
              })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.back")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (completeClassReviewModal.value = true)),
            class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex flex-wrap disabled:opacity-50"
          }, _toDisplayString(_ctx.$t("rollover.review_class_structure_screen.confirm_email_teachers")), 1)
        ])
      ]),
      _createVNode(_component_modal, {
        showCloseButton: true,
        widthClass: 'max-w-lg',
        open: showAddGradeConfirm.value,
        onLocalModalOpen: _cache[4] || (_cache[4] = ($event: any) => (showAddGradeConfirm.value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-two-people',
                title: 'rl two people',
                "aria-hidden": "true"
              })
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.$t("admin_screens.modals.add_new_grade_header")) + "!", 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("p", _hoisted_27, [
                _createTextVNode(_toDisplayString(_ctx.$t("admin_screens.modals.are_you_sure")) + " " + _toDisplayString(selectedGrade.value), 1),
                _hoisted_28,
                _createTextVNode(" " + _toDisplayString(_ctx.$t("admin_screens.modals.to_the_program")) + "? ", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("button", {
                type: "button",
                class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (cancelSelection()))
              }, _toDisplayString(_ctx.$t("admin_screens.modals.cancel")), 1),
              _createElementVNode("button", {
                type: "button",
                class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap w-full",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (confirmSelection(selectedGrade.value)))
              }, _toDisplayString(_ctx.$t("admin_screens.modals.im_sure")), 1)
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_component_modal, {
        showCloseButton: true,
        widthClass: 'max-w-xl',
        open: completeClassReviewModal.value,
        onLocalModalOpen: _cache[6] || (_cache[6] = ($event: any) => (completeClassReviewModal.value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_rl_icon, {
                  icon: 'rl-rollover-mail',
                  title: 'rl rollover mail',
                  "aria-hidden": "true"
                })
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("h3", _hoisted_33, _toDisplayString(_ctx.$t(
                  "rollover.modal.review_class_structure.class_structure_complete"
                )), 1)
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t(
                  "rollover.modal.review_class_structure.final_step_text"
                )) + ". ", 1),
                _createElementVNode("p", _hoisted_36, _toDisplayString(_ctx.$t(
                  "rollover.modal.review_class_structure.teacher_emails_text"
                )) + ". ", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (confirmClassReview())),
                type: "button",
                class: "bg-blue-600 rounded-lg p-2.5 text-base shadow-lg text-white mx-2 flex flex-row justify-center items-center flex-wrap w-full"
              }, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.confirm")), 1),
              _createVNode(_component_router_link, { to: "/main/internal" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.not_ready")) + "?", 1),
                    _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.back_later")), 1)
                  ])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"]),
      _createVNode(_component_modal, {
        showCloseButton: true,
        widthClass: 'max-w-xl',
        open: goToAssignModal.value,
        onLocalModalOpen: _cache[8] || (_cache[8] = ($event: any) => (goToAssignModal.value = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("span", _hoisted_43, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-rollover-mail',
                    title: 'rl rollover mail',
                    "aria-hidden": "true"
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("h3", _hoisted_45, _toDisplayString(_ctx.$t(
                  "rollover.modal.review_class_structure.almost_there"
                )) + "!", 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t(
                  "rollover.modal.review_class_structure.final_step_text"
                )) + ". ", 1),
                _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.$t(
                  "rollover.modal.review_class_structure.student_assigned_text"
                )) + ". ", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _createVNode(_component_router_link, { to: "/main/add-student" }, {
                default: _withCtx(() => [
                  _createElementVNode("button", _hoisted_50, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.assign")), 1)
                ]),
                _: 1
              }),
              _createElementVNode("button", {
                type: "button",
                class: "px-8 py-2 text-base mt-3 flex flex-row justify-evenly items-center flex-wrap w-full",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (goToAssignModal.value = false))
              }, [
                _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.not_ready")) + "?", 1),
                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.$t("rollover.modal.review_class_structure.back_later")), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _createVNode(TutorialModalComponent, {
      show: showModal.value,
      "onUpdate:show": _cache[9] || (_cache[9] = ($event: any) => ((showModal).value = $event))
    }, {
      headerSlot: _withCtx(() => [
        _createTextVNode(" Tutorial ")
      ]),
      descriptionSlot: _withCtx(() => [
        _createTextVNode(" Lorem ipsum dolor sit amet consectetur adipisicing elit. Accusamus commodi, suscipit, unde deleniti distinctio qui culpa vero repudiandae eum provident laudantium officia laboriosam harum iste fugit nobis minus, consectetur dolorem. ")
      ]),
      strapiContent: _withCtx(() => [
        _createTextVNode(" Strapi content to go here... ")
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})